<template lang="pug">
div
  Form(:data="questionType", :isSubmitting="isSubmitting", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useQuestionTypeEdit from './useQuestionTypeEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, questionType, isSubmitting } = useQuestionTypeEdit()

    onMounted(show)

    return {
      questionType,
      update,
      isSubmitting,
    }
  },
}
</script>
